import domtoimage from "dom-to-image";
import _ from "lodash";
import { ajax } from "../../app/core/ajax";
import * as z from "../../framework";
import * as dateUtil from "../core/dateTime";
import * as divisionRegion from "../core/division.region";
import { ll } from "../core/ll";
import { user } from "../core/user";
import { searchTypes } from "../data/searchTypes";

export function handleRequestsForPieChart(options) {

    // Used to reset the filter and select to prevent the additions from being repeatedly appended.
    var oldFilter = options.filter;
    var oldSelect = options.select;

    if (!options.filtered && options.filter == options.originalFilter && user && user.companyData && user.companyData.DivisionAndRegionEnabled) {
        retrieveRegionAndDivisionFiltering(options);
    }

    var amIDoneYet = $.Deferred(),
        chart = options.chart,
        pieChartData: any = [],
        ajaxCalls = 0;

    if (!options.select) {
        options.select = "Id";
    }

    options.inlinecount = "allpages";
    options.top = 0;

    if (options.dateInterval) {
        var daysAgo = options.dateInterval * options.dateIntervals;
        var now = new Date();
        var greaterThanDateString = new Date();

        greaterThanDateString.setDate(greaterThanDateString.getDate() - daysAgo);
        greaterThanDateString = dateUtil.buildUTCString(greaterThanDateString);

        options.filter = `${options.filter} AND ${options.xAxis} ge '${greaterThanDateString}'`;

        options.select = `${options.select}, ${options.xAxis}`;

        options.orderby = `${options.xAxis} desc`;

        options.top = "10000";

        options.inlinecount = "none";

        $.ajax(buildRequest(options)).done(function (response) {
            var results = response.d.results;

            for (var ii = 0; ii <= options.dateIntervals; ii++) {
                var endInterval = options.dateInterval * ii;
                var startInterval = options.dateInterval * (ii + 1);
                var endDatePeriod = new Date(now.getTime());
                var startDatePeriod = new Date(now.getTime());

                endDatePeriod.setDate(endDatePeriod.getDate() - endInterval);
                startDatePeriod.setDate(startDatePeriod.getDate() - startInterval);

                var category = ll("DaysAgo").format(endInterval);
                if (endInterval == 0) {
                    category = ll("Newer");
                }

                var range = {
                    endDate: new Date(endDatePeriod),
                    startDate: new Date(startDatePeriod),
                    category: category,
                    value: 0
                };
                pieChartData.push(range);
            }

            _.each(pieChartData, function (data, index) {
                var counter = 0;
                _.each(results, function (result){
                    var resultDate = new Date(result[options.xAxis]);
                    if (resultDate >= data.startDate  && resultDate < data.endDate) {
                        counter++;
                    }
                });

                pieChartData[index].value = counter;
            });

            amIDoneYet.resolve();

        });

    } else {
        var dateFilter;
        pieChartData = {};
        if (options.filterDate) {
            dateFilter = new Date();
            dateFilter.setDate(dateFilter.getDate() - 30);
            dateFilter = "'" + dateUtil.buildUTCString(dateFilter) + "'";
        }

        if (options.groupByFilter) {
            // we will need to add this to json to get better groupings than just a call to an entity like OrderStatus, or a Maintenance code
        }

        var groupBy = z.codes[options.groupBy];
        var gotGroupByData = $.Deferred();

        if (!groupBy) {
            ajax({
                type: "GET",
                url: options.groupBy
            }).done(function (response) {
                groupBy = response.d.results;
                gotGroupByData.resolve(groupBy);
            });
        } else {
            gotGroupByData.resolve(groupBy);
        }

        $.when(gotGroupByData).done(function (groupByData: any){

            _.each(groupByData, function (groupByObject){
                if (groupByObject.Id > 0) {
                    pieChartData[groupByObject.Id] = {
                        category: groupByObject.CodeNumber,
                        id: groupByObject.Id,
                        value: 0
                    };
                }
            });

            var url = `${options.entityType}?$top=10000&$select=${options.filterId}`;
            if (options.filterId && options.filter) {

                var filterDateString = options.filter;
                filterDateString = filterDateString.replace("@Date", dateFilter);

                url = `${url}&$filter=${filterDateString}`;
            }

            ajax({
                url: url
            }).done(function (data){

                _.each(data.d.results, (row) => {
                    var group = pieChartData[row[options.filterId]];
                    if (group) {
                        group.value++;
                    }
                });

                amIDoneYet.resolve();
            });
        });
    }

    amIDoneYet.done(function () {
        renderPieChart({
            chart: chart,
            template: options.template,
            pieChartData: pieChartData,
            id: options.id,
            screenId: options.id,
            title: options.title,
            theme: options.theme
        });
        $("#" + options.id).show();
        $("#" + options.id).unmask();

    });

    // Resets the filter and select to prevent the additions from being repeatedly appended.
    options.filter = oldFilter;
    options.select = oldSelect;

    return pieChartData;
}

export function buildRequest(options) {
    var url = options.url,
        hasQuestionMark = false;

    if (options.select) {
        if (!hasQuestionMark) {
            url += "?";
            hasQuestionMark = true;
        }

        url += "$select=" + options.select;
    }

    if (options.expand) {
        if (!hasQuestionMark) {
            url += "?";
            hasQuestionMark = true;
        } else {
            url += "&";
        }

        url += "$expand=" + options.expand;
    }

    if (options.filter) {
        if (!hasQuestionMark) {
            url += "?";
            hasQuestionMark = true;
        } else {
            url += "&";
        }

        url += "$filter=" + options.filter;
    }

    if (options.inlinecount) {
        if (!hasQuestionMark) {
            url += "?";
            hasQuestionMark = true;
        } else {
            url += "&";
        }

        url += "$inlinecount=" + options.inlinecount;
    }

    if (options.top != null) {
        if (!hasQuestionMark) {
            url += "?";
            hasQuestionMark = true;
        } else {
            url += "&";
        }

        url += "$top=" + options.top;
    }

    if (options.skip != null) {
        if (!hasQuestionMark) {
            url += "?";
            hasQuestionMark = true;
        } else {
            url += "&";
        }

        url += "$skip=" + options.skip;
    }

    if (options.pageSize != null) {
        if (!hasQuestionMark) {
            url += "?";
            hasQuestionMark = true;
        } else {
            url += "&";
        }

        url += "$pageSize=" + options.pageSize;
    }

    if (options.orderby) {
        if (!hasQuestionMark) {
            url += "?";
            hasQuestionMark = true;
        } else {
            url += "&";
        }

        url += "$orderby=" + options.orderby;
    }

    return {
        type: "GET",
        url: url
    };
}

function retrieveRegionAndDivisionFiltering(options) {
    var searchTypeInfo = searchTypes["" + options.entityType + ""];

    if (!searchTypeInfo) {
        searchTypeInfo = { divisionsNavigationTypes: "", regionsNavigationTypes: "" };
    }

    if (options.divisions) {
        var divisionsNavType = (options.divisionsNavigationTypes || searchTypeInfo.divisionsNavigationTypes) || "";
        options.DivisionsNavigationTypes = divisionsNavType;
        var divFilter = divisionRegion.createDivisionsFilterStrings(-2, divisionsNavType);
        if (divFilter) {
            options.filter += " and " + divFilter;
        }
    }

    if (options.regions) {
        var regionNavType = (options.regionsNavigationTypes || searchTypeInfo.regionsNavigationTypes) || "";
        options.regionsNavigationTypes = regionNavType;
        var regionFilter = regionNavType + "Region/EmployeeRegion/UserId eq " + user.loginData.UserId;
        options.filter += " and " + regionFilter;
    }
}

function renderPieChart(args) {
    var hasData = false;
    var jqueryChartObject = $("#" + args.id);
    var contentsPanel = jqueryChartObject.closest(".z-widget-contents");
    contentsPanel.remove(".chart-overlay-message");
    _.each(args.pieChartData, function (period) {
        if (!hasData && period.value > 0) {
            hasData = true;
        }
    });

    $("#" + args.id).kendoChart({
        theme: args.theme || "Flat",
        height: 400,
        legend: {
            visible: false
        },
        visible: hasData,
        chartArea: {
            background: "",
            width: contentsPanel.width(),
            margin: {
                top: 30,
                bottom: 30,
                left: 80,
                right: 80
            }
        },
        seriesDefaults: {
            labels: {
                visible: true,
                background: "transparent",
                template: args.template
            }
        },
        series: [{
            type: "pie",
            startAngle: 150,
            data: args.pieChartData
        }],
        tooltip: {
            visible: true,
            format: "",
            template: args.template
        }
    } as any);

    var widgetTitle = args.title;
    var screenIndx = args.screenId.indexOf("_");
    var screenId = args.screenId.substr(0, screenIndx);

    $("#" + screenId + "_WidgetContainer_PrintButton").off().tie("click", function () {
        var node = document.getElementById(screenId + "_WidgetContainer");
        domtoimage.toPng(node).then(function (dataUrl) {
            kendo.saveAs({
                dataURI: dataUrl,
                fileName: widgetTitle + " Export.png"
            });
        });
    });

    var noDataWarning = contentsPanel.find(".chart-overlay-message");

    if (!hasData && noDataWarning && noDataWarning.length == 0) {
        jqueryChartObject.addClass("hidden");
        contentsPanel.append("<div class=\"chart-overlay-message\">{0}</div>".format(ll("NoDataWarning")));
    } else if (hasData) {
        jqueryChartObject.removeClass("hidden");
        contentsPanel.find(".chart-overlay-message").remove();
    }
}
